import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import Home from './views/home/home.vue'
import LoginHome from './views/home/login.vue'
import OutlookHome from './views/outlook/home.vue'
import OutlookEmailInfo from './views/outlook/email-info.vue'
import CreateOrganisation from './views/entity/create-organisation.vue'
import CreatePerson from './views/entity/create-person.vue'
import CreateEntity from './views/entity/create-entity.vue'

Vue.use(VueRouter);

const routes: RouteConfig[] = [
    {
        path: '/',
        name: 'home',
        component: Home,
    },
    {
        path: '/login',
        name: 'login-home',
        component: LoginHome,
    },
    {
        path: '/outlook',
        name: 'outlook-home',
        component: OutlookHome,
        children: [
            {
                path: '',
                name: 'outlook-emailInfo',
                component: OutlookEmailInfo,
            },
            {
                path: 'organisation/create',
                name: 'outlook-organisation-create',
                component: CreateOrganisation,
            },
            {
                path: 'person/create',
                name: 'outlook-person-create',
                component: CreatePerson,
            },
            {
                path: 'entity/create',
                name: 'outlook-entity-create',
                component: CreateEntity,
            },
        ]
    }
];

const router = new VueRouter({
    mode: 'history',
    routes
});

export default router;
